import { FadeUp } from "@/components/Reveal";
import { ArrowButton } from "@/components/ArrowButton";
import { waLink } from "@/data/site";

const CtaBand = ({ title = "Vamos conversar?", text = "Conte brevemente o que você está buscando. O primeiro contato pode ajudar a compreender melhor a sua demanda." }) => (
  <section data-testid="cta-band" className="bg-raiz-800 py-20 text-center text-paper lg:py-28">
    <div className="container-x">
      <FadeUp>
        <img src="/assets/tree-mark-white.png" alt="" className="mx-auto h-12 w-auto opacity-90" width="48" height="48" />
      </FadeUp>
      <FadeUp delay={0.08}>
        <h2 className="mx-auto mt-8 max-w-2xl font-serif text-3xl font-light leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl" data-testid="cta-band-title">
          {title}
        </h2>
      </FadeUp>
      <FadeUp delay={0.16}>
        <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-raiz-100/75">{text}</p>
      </FadeUp>
      <FadeUp delay={0.24} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <ArrowButton href={waLink()} target="_blank" rel="noopener noreferrer" variant="light" testId="cta-band-whatsapp-button">
          Agendar uma conversa
        </ArrowButton>
        <ArrowButton to="/contato" variant="outlineLight" testId="cta-band-contato-button">
          Enviar contato
        </ArrowButton>
      </FadeUp>
    </div>
  </section>
);

export default CtaBand;
